import { TtTableWrapper } from './TtTableWrapper.js';

if (typeof window !== 'undefined') {
  if (!window.customElements.get('tt-table-wrapper')) {
    window.customElements.define('tt-table-wrapper', TtTableWrapper);
  }
}

export { TtTableWrapper };
